import { nanoid } from 'nanoid'

/**
 * @property {String} id - id of the table item
 */

export default class SimpleTableItem {
  constructor() {
    this.id = nanoid()

    /**
     * Whether the table item is removed or not (only relevant if removable prop active)
     * @type {Boolean}
     */
    this.removed = false
  }
}
